import { createStore } from "vuex";
import axios from "axios";
import router from "../router";
export default createStore({
  state: {
    // baseUrl: "http://192.168.1.188/amlak/shomalamlak/api",
    //baseUrl: "http://194.147.142.110/panel/api",
    baseUrl: "https://shomalamlak.ir/panel/api",
    _token: "",
    device: "",
    c_set: [],
    show: false,
    auth: {
      loggedIn: false,
    },
    post_detail: [],
    post_fillter: [],
    login_modal: false,
    theme: "light",
  },

  getters: {
    baseUrl: function (state) {
      return state.baseUrl;
    },
    device: function (state) {
      return state.device;
    },
    appToken: function (state) {
      return state._token;
    },
    auth: function (state) {
      return state.auth;
    },
    c_set: function (state) {
      return state.c_set;
    },
    post_detail: function (state) {
      return state.post_detail;
    },
    post_fillter: function (state) {
      return state.post_fillter;
    },
    fire: function (state) {
      return state.fire;
    },
    theme: (state) => state.theme,
  },
  mutations: {
    setTheme(state, theme) {
      state.theme = theme;
    },
    setToken(state, payload) {
      state._token = payload;
      localStorage.setItem("_token", JSON.stringify(payload));
    },
    setDevice(state, payload) {
      state.device = payload;
    },
    setAuth(state, payload) {
      state.auth = payload;
      localStorage.setItem("auth", JSON.stringify(payload));
      state.auth.loggedIn = true;
    },
    setFire(state, payload) {
      localStorage.setItem("fire", JSON.stringify(payload));
      state.fire = payload;
    },
    checkToken(state) {
      const token = localStorage.getItem("_token");
      if (token) state._token = JSON.parse(token);
      else localStorage.removeItem("_token");
      setTimeout(function () {
        let route = router.currentRoute._value.path;
        console.log("route", route);
        if (route != "/details") localStorage.removeItem("post_detail");

        if (route != "/category" && route != "/details")
          localStorage.removeItem("post_fillter");
      }, 500);
    },
    checkAuth(state) {
      const auth = localStorage.getItem("auth");
      if (auth) {
        state.auth = JSON.parse(auth);
        state.auth.loggedIn = true;
      }
      //اگر به هر دلیلی storage auth حذف شد میاد اینجا
      else {
        axios
          .post(
            state.baseUrl + "/current-user-info",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + state._token,
              },
            }
          )
          .then((r) => {
            if (r.data.result == "1") {
              state.auth = r.data;
              localStorage.setItem("auth", JSON.stringify(r.data));
              state.auth.loggedIn = true;
            } else {
              localStorage.removeItem("_token");
            }
          })
          .catch(function () {
            localStorage.removeItem("_token");
          });
      }
    },
    optionSet(state, payload) {
      state.c_set = payload;
    },
    post_detail_set(state, payload) {
      const detail = localStorage.getItem("post_detail");
      if (detail) {
        state.post_detail = JSON.parse(detail);
      } else {
        if (payload) {
          state.post_detail = payload;
          localStorage.setItem("post_detail", JSON.stringify(payload));
        } else {
          router.push({ path: "/" });
        }
      }
    },
    post_fillter_set(state, payload) {
      const fillter = localStorage.getItem("post_fillter");
      // console.log('mypost_fillter',fillter)
      if (fillter) {
        state.post_fillter = JSON.parse(fillter);
      } else {
        if (payload) {
          // console.log('mypost_fillterpayload',payload)
          state.post_fillter = payload;
          localStorage.setItem("post_fillter", JSON.stringify(payload));
        } else {
          state.post_fillter = [];
        }
      }
    },
  },
  actions: {
    checkToken({ commit }) {
      commit("checkToken");
    },
    setFire({ commit }, payload) {
      localStorage.setItem("fire", JSON.stringify(payload));
      commit("setFire", payload);
    },
    checkAuth({ commit }) {
      commit("checkAuth");
    },
    checkPostDetail({ commit }) {
      commit("post_detail_set");
    },
    checkPostFillter({ commit }) {
      commit("post_fillter_set");
    },
  },
  modules: {},
});
